export enum AlternateWorkflowType {
	Phase = 1,
	CaseClosure = 2,
	Eligibility = 3,
}